/* eslint-disable import/no-unresolved */
import React, { useContext, useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import CookieBanner from './components/cookie-banner'
export const applicationContext = React.createContext()

const Provider = ({ children }) => {

  const [cookieBanner, setCookieBanner] = useState({});
  // const [acceptCookies, setAcceptCookies] = useState(false);
  
  const handleBarCompiler =
    typeof window !== `undefined`
      ? new window.BTHandlebarLib.HandleBarCompiler({ ext: 'hbs' })
      : { compile: () => {} }
    useEffect(()=>{
      let cookieBannerInfo = typeof window !== `undefined` && window.__INITIALDATA__ && window.__INITIALDATA__.cookieBannerInfo;
      // let isAcceptCookiesClicked = typeof window !== `undefined` && window.acceptCookiesClicked;
      setCookieBanner(cookieBannerInfo);
      // setAcceptCookies(isAcceptCookiesClicked);
    },[])
  return (
    <applicationContext.Provider value={{ Cookies, handleBarCompiler }}>
      {children}
      <CookieBanner cookieBannerInfo={cookieBanner}/>
    </applicationContext.Provider>
  )
}

const ProviderComponent = ({ element }) => <Provider>{element}</Provider>

export default ProviderComponent

export const useApplicationContext = () => useContext(applicationContext)
